export default "__VITE_ASSET__dnpkzhT3__"